import React, { useState } from 'react'
import Loader from '../Loader/Loader'
import { message, Button } from "antd";
import { useFormik } from 'formik'
import * as Yup from "yup";
import { editFilterCategory, deleteSubCategory } from '../../Web Apis/Apis';


function UpdateFilter({ showUpdateModalOpen, setShowUpdateModalOpen, action, setAction, selectedCategory }) {
    const [open, setOpen] = useState(showUpdateModalOpen)
    const [loading, setLoading] = useState(false)
    const [subcategories, setSubCategories] = useState(selectedCategory.subcategory)
    const [showDeleteSubCategory, setShowDeleteSubCategory] = useState(false)
    const [selectedSubCategory, setSelectedSubCategory] = useState({})

    const handleCloseModal = () => {
        setOpen(false)
        setShowUpdateModalOpen(false)
    }



    const formik = useFormik({
        initialValues: {
            categoryName: selectedCategory.category,
            subcategories: selectedCategory.subcategory
        },
        validationSchema: Yup.object({
            categoryName: Yup.string().required("Category name is required")
                .max(50, "Category name should not be more than 50 characters")
                .min(3, "Category name should be atleast 3 characters long")
                .trim("Category name should not have spaces")
                .matches(/^[a-zA-Z\s]*$/, "Category name should not contain special characters or numbers"),
            // subCategories: Yup.string().required("Subcategory name is required")
            // .max(50, "Subcategory name should not be more than 50 characters")
            // .min(3, "Subcategory name should be atleast 3 characters long")
            // .trim("Subcategory name should not have spaces")
            // .matches(/^[a-zA-Z\s]*$/, "Subcategory name should not contain special characters or numbers"),
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                setLoading(true)

                // let data = new FormData()
                // data.append("categoryName", values.categoryName)
                // data.append("subcategories", values.subCategories)

                const data = {
                    ...values, subcategories: subcategories
                        .slice(selectedCategory?.subcategories?.length || 0)
                        .map((sub) => sub.subCategory)
                    // .filter((subCategory) => subCategory && subCategory.trim() !== "")
                } // Adding sub category

                // if (data.subcategories.length < 1) {
                //     message.error("Filter category should contain atleast one sub category")
                //     return;
                // }

                const response = await editFilterCategory(selectedCategory.id, data)

                if (response?.data?.success) {
                    resetForm()
                    setOpen(false)
                    setShowUpdateModalOpen(false)
                    setAction(!action)
                }

            } catch (error) {
                console.log("Error while creating admin", error.message)
                message.error(error?.response?.data?.message || "Error while creating admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })

    // function to add new sub category
    const addSubCategory = () => {
        setSubCategories([...subcategories, { subCategory: "" }])
    }

    // function to remove sub category
    const removeSubCategory = (index) => {
        const newSubCategory = subcategories.filter((_, i) => i !== index);
        setSubCategories(newSubCategory)
    }

    // function to handle sub category input changes
    const handleSubCategoryChange = (index, event) => {
        const newSubCategory = [...subcategories];
        newSubCategory[index].subCategory = event.target.value;
        setSubCategories(newSubCategory)
    }


    const handleDeleteSubCategory = async () => {
        try {
            setLoading(true)
            const response = await deleteSubCategory(selectedSubCategory)
            if (response?.data?.success) {
                message.success(response?.data?.message)
                setShowDeleteSubCategory(false)
                setShowUpdateModalOpen(false)
                setOpen(false)
                setAction(!action)
            }

        } catch (error) {
            console.log("Error while deleting category", error.message)
            message.error(error?.response?.data?.message || "Error occured")
        } finally {
            setLoading(false)
        }
    }

    const openDeleteModal = (item) => {

        setSelectedSubCategory(item)
        setShowDeleteSubCategory(true)
    }



    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-2xl shadow-lg w-[900px] h-[500px] overflow-y-auto">

                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    Update Filter Category
                </h3>

                <form onSubmit={formik.handleSubmit} className='p-8'>

                    <div className="w-full">
                        <label className="block mb-1 mt-8 text-xl font-bold">Filter category name </label>
                        <input
                            type="text"
                            name="categoryName"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.categoryName}
                            placeholder='Enter occassion category name'
                        />
                        {formik.touched.categoryName && formik.errors.categoryName && (
                            <p className="text-red-600 ml-2">{formik.errors.categoryName}</p>
                        )}
                    </div>


                    {subcategories.map((item, index) => (
                        <div className='mb-4' key={index}>
                            <label className="block mb-1 mt-8 text-xl font-bold">Sub category name {index + 1} </label>
                            <div className='flex items-center'>
                                <input
                                    type='text'
                                    name={`subCategory-${index}`}
                                    className='border border-gray-800 p-2 w-full'
                                    disabled={item?.id}
                                    value={item.subcategory}
                                    onChange={(e) => handleSubCategoryChange(index, e)}
                                />
                                {item?.id && (
                                    <Button
                                        type="danger"
                                        onClick={() => openDeleteModal(item)}
                                        className="border border-gray-800 ml-2"
                                    >
                                        Delete
                                    </Button>
                                )}

                                {!item?.id && (
                                    <Button
                                        type="danger"
                                        onClick={() => removeSubCategory(index)}
                                        className="border border-gray-800 ml-2"
                                    >
                                        Remove
                                    </Button>
                                )}

                            </div>
                        </div>
                    ))}


                    <Button type="dashed" onClick={addSubCategory}
                        className="border border-gray-800"
                    >
                        Add Sub Category
                    </Button>




                    <div className="flex justify-center gap-6 mt-6">
                        <button
                            onClick={handleCloseModal}
                            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            {formik.isSubmitting ? "Updating.." : "Update"}
                        </button>
                    </div>

                    {loading && <Loader />}
                </form>
            </div>

            {showDeleteSubCategory && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm Delete</h3>
                        <p className="mb-4 text-start text-white">Are you sure you want to delete this sub category ? </p>
                        <div className="flex justify-end gap-4">
                            <button onClick={() => { setShowDeleteSubCategory(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                                Cancel
                            </button>
                            <button onClick={handleDeleteSubCategory} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default UpdateFilter